export enum DocumentModuleTypes {
  HR = 0,
  Accounting = 1,
  Standard = 2,
}
